export enum ContractorProjectDocFolderActions {
    SendForApproval = 100,
    CancelApproval = 101,
    UploadAttachment = 102,
    DeleteAttachment = 103,
    EditAct = 104,
    RefreshActSigners = 105,
    DeleteAct = 106,
    DeleteDocument = 107
}
